import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useMemo } from 'react';
import strings from '../../Globalization';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import util from '../../util';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';
import { evalCriticalParameters } from './dataUtil';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));

const CriticalParametersTable = () => {
	const { data } = useCycleInfo();
	const dateTimeFormat = util.getDateTimeFormat();

	const columns = [
		{ name: 'HeaderLabel', label: strings.Parameter },
		{ name: 'MetricDataProperty1', label: strings.Metric },
		{ name: 'ActualDataProperty1', label: strings.Actual },
		{ name: 'CriticalParameterIcon', label: strings.CriticalParamenterTitle }
	];

	const evalRowCells = (rowData, i) => {

		let metricValue = `${rowData.MetricDataProperty1 ?? ''}`
		if (typeof rowData.MetricDataProperty2 !== 'undefined' && rowData.MetricDataProperty2 !== null) {
			metricValue += `${metricValue?.length > 0 ? ' - ' : ''}${rowData.MetricDataProperty2}`;
		}
		let actualValue = `${rowData.ActualDataProperty1 ?? ''}`;
		if (typeof rowData.ActualDataProperty2 !== 'undefined') {
			actualValue += `${actualValue?.length > 0 ? ' - ' : ''}${rowData.ActualDataProperty2}`;
		}
		return [
			<TableCell key={`row-${i}-HeaderLabel`}>
				{rowData.HeaderLabel}
			</TableCell>,
			<TableCell key={`row-${i}-MetricDataProperty1`}>{rowData.Metric}</TableCell>,
			<TableCell key={`row-${i}-ActualDataProperty1`}>{rowData.Actual}</TableCell>,
			<TableCell key={`row-${i}-CriticalParameterIcon`}>
				<ProcessMonitoringStatus CriticalParameterIcon={rowData.CriticalParameterIcon} align={'center'} ml={1} width={100} />	
			</TableCell>
		];
	}

	const rows = useMemo(() => evalCriticalParameters({ data, dateTimeFormat }).map(evalRowCells), [data, dateTimeFormat]);

	return (
		rows.length > 0 && (
			<TableContainer component={Box}>
				<Table size="small" aria-label="Critical parameters table">
					<TableHead>
						<TableRow>
							{columns.map((column, index) => (
								<TableCell key={`column-${index}`}>{column.label}</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((cells, i) => (
							<StyledTableRow key={`row-${i}`}>{cells}</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		)
	);
};
export default CriticalParametersTable;
